class MainBlogPosts extends HTMLElement {
  constructor() {
    super();

    const tag_list = this.querySelector('.tag-list');
    const tag_a = tag_list.querySelectorAll('a');

    tag_a.forEach(item => {
      item.addEventListener('click', event => {
        tag_a.forEach(item => {
          item.classList.remove('active');
        })
        event.target.classList.add('active');

        const tag_selected = event.target.dataset.tag;
        this.filterPosts(tag_selected);
      })
    })
  }

  filterPosts(tag_selected){

    const post_list = this.querySelector('.blog-articles-holder');
    const posts = post_list.querySelectorAll('.article-post');

    posts.forEach(post => {
      if(tag_selected == 'All') {
          post.classList.remove('d-none')
      } else {
        const post_tags = JSON.parse(post.dataset.tags);
        if(post_tags.includes(tag_selected)){
          post.classList.remove('d-none')
        } else {
          post.classList.add('d-none')
        }
      }
    });



  }


}

customElements.define('main-blog-posts', MainBlogPosts);
